// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cr-page .dashboard-body {
  padding-bottom: 2rem;
}

.cr-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.cr-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.cr-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.95rem 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.cr-stat span,
.cr-stat small {
  display: block;
  font-size: 0.78rem;
  color: #64748b;
}

.cr-stat small {
  margin-top: 0.2rem;
}

.cr-stat strong {
  display: block;
  font-size: 1.25rem;
  color: #0f172a;
  margin: 0.15rem 0;
}

.cr-charts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.cr-chart-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.cr-chart-card h3 {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
  color: #0f172a;
}

.cr-chart-card__body {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.cr-donut {
  position: relative;
  flex-shrink: 0;
}

.cr-donut__center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.cr-donut__center strong {
  font-size: 0.95rem;
  color: #0f172a;
}

.cr-donut__center span {
  font-size: 0.7rem;
  color: #64748b;
}

.cr-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: #475569;
}

.cr-legend li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.cr-legend span {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex-shrink: 0;
}

.cr-legend strong {
  margin-left: auto;
  color: #0f172a;
}

.cr-bars {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cr-bar-row {
  display: grid;
  grid-template-columns: 88px 1fr 72px;
  gap: 0.5rem;
  align-items: center;
  font-size: 0.78rem;
}

.cr-bar-row__label {
  color: #475569;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cr-bar-row__track {
  height: 10px;
  background: #f1f5f9;
  border-radius: 999px;
  overflow: hidden;
}

.cr-bar-row__fill {
  height: 100%;
  border-radius: 999px;
  min-width: 0;
}

.cr-bar-row__value {
  text-align: right;
  font-weight: 700;
  color: #0f172a;
}

.cr-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 1rem;
}

.cr-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: flex-end;
  margin-bottom: 0.9rem;
}

.cr-toolbar form,
.cr-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  align-items: flex-end;
  flex: 1 1 280px;
}

.cr-toolbar input,
.cr-toolbar select,
.cr-filters input,
.cr-filters select {
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  padding: 0.45rem 0.65rem;
  font-size: 0.86rem;
  font-family: inherit;
}

.cr-toolbar form input[type="search"] {
  flex: 1 1;
  min-width: 180px;
}

.cr-toolbar label,
.cr-filters label {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
}

.cr-toolbar button,
.cr-btn-view,
.cr-btn-primary {
  border: none;
  border-radius: 8px;
  padding: 0.45rem 0.8rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
  font-family: inherit;
}

.cr-btn-ghost {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 8px;
  padding: 0.45rem 0.8rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.cr-export {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  border-radius: 8px;
  padding: 0.45rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
  cursor: pointer;
  font-family: inherit;
}

.cr-export:disabled,
.cr-btn-primary:disabled,
.cr-btn-view:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.cr-toast {
  margin: 0 0 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.85rem;
}

.cr-toast--success {
  color: #166534;
  background: rgba(22, 101, 52, 0.1);
}

.cr-toast--error {
  color: #b91c1c;
  background: rgba(220, 38, 38, 0.08);
}

.cr-empty {
  text-align: center;
  color: #64748b;
  padding: 1.5rem 0.6rem;
}

.cr-empty i {
  display: block;
  font-size: 1.5rem;
  margin-bottom: 0.45rem;
}

.cr-table-wrap {
  overflow-x: auto;
}

.cr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.cr-table th {
  padding: 0.7rem 0.75rem;
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #f8fafc;
  background: #0f172a;
  white-space: nowrap;
}

.cr-table td {
  padding: 0.7rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
  vertical-align: top;
}

.cr-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.cr-table--nested {
  font-size: 0.8rem;
}

.cr-table--nested th {
  background: #334155;
}

.cr-nested-cell {
  background: #f8fafc !important;
  padding: 0.6rem 0.75rem 1rem !important;
}

.cr-user-mini {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.cr-user-mini strong {
  color: #0f172a;
}

.cr-user-mini span {
  font-size: 0.75rem;
  color: #64748b;
}

.cr-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.48rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
}

.cr-chip--ok {
  background: rgba(13, 148, 136, 0.14);
  color: #0f766e;
}

.cr-chip--pending {
  background: rgba(217, 119, 6, 0.14);
  color: #b45309;
}

.cr-chip--bad {
  background: rgba(220, 38, 38, 0.12);
  color: #b91c1c;
}

.cr-chip--muted {
  background: #f1f5f9;
  color: #64748b;
}

.cr-chip--level {
  background: rgba(15, 118, 110, 0.12);
  color: #0f766e;
}

.cr-chip--staking {
  background: rgba(15, 118, 110, 0.12);
  color: #0f766e;
}

.cr-chip--brokerage {
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
}

.cr-chip--buy {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.cr-chip--sell {
  background: rgba(220, 38, 38, 0.12);
  color: #b91c1c;
}

.cr-pagination {
  margin-top: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: #64748b;
}

.cr-pagination label {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.72rem;
  font-weight: 700;
}

.cr-pagination select,
.cr-pagination button {
  border: 1px solid #dbe2ea;
  background: #fff;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  font-family: inherit;
  cursor: pointer;
}

.cr-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cr-pagination div {
  display: flex;
  gap: 0.4rem;
}

.cr-help {
  margin: 0 0 1rem;
  padding: 0.65rem 0.8rem;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  border-radius: 10px;
  color: #0f766e;
  font-size: 0.85rem;
}

.cr-muted {
  color: #64748b;
  font-size: 0.85rem;
  margin: 0;
}

.cr-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.cr-tabs {
  display: flex;
  gap: 0.45rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.cr-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 0.5rem 0.95rem;
  font-size: 0.86rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
}

.cr-tab--active {
  color: #fff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
}

.cr-tab__count {
  font-weight: 600;
  opacity: 0.85;
}

.cr-detail-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.7rem;
  margin-bottom: 0.85rem;
}

.cr-detail-head h2 {
  margin: 0;
  font-size: 1.15rem;
  color: #0f172a;
}

.cr-detail-head p {
  margin: 0.2rem 0 0;
  color: #64748b;
  font-size: 0.85rem;
}

.cr-detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: center;
  margin-bottom: 0.85rem;
  font-size: 0.85rem;
  color: #475569;
}

.cr-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.7rem;
  margin-bottom: 1rem;
}

.cr-stat-grid div {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.7rem 0.8rem;
}

.cr-stat-grid span,
.cr-stat-grid small {
  display: block;
  color: #64748b;
  font-size: 0.72rem;
}

.cr-stat-grid strong {
  display: block;
  margin: 0.2rem 0;
  font-size: 1.05rem;
  color: #0f172a;
}

.cr-flow {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.75rem;
  align-items: stretch;
  margin-bottom: 1rem;
}

.cr-flow__box {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9rem 1rem;
}

.cr-flow__box h3 {
  margin: 0 0 0.35rem;
  font-size: 0.88rem;
  color: #0f172a;
}

.cr-flow__box p {
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
}

.cr-flow__box strong {
  display: block;
  margin: 0.35rem 0 0.15rem;
  font-size: 1.2rem;
  color: #0f172a;
}

.cr-flow__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f766e;
  font-size: 1.2rem;
}

.cr-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

.cr-preview-head h3 {
  margin: 0;
  font-size: 0.95rem;
  color: #0f172a;
}

.cr-level-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.cr-level-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.7rem;
}

.cr-level-card__lvl {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  color: #0f766e;
  text-transform: uppercase;
}

.cr-level-card__count {
  display: block;
  font-size: 1.2rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0.15rem 0;
}

.cr-level-card ul {
  list-style: none;
  margin: 0.35rem 0 0;
  padding: 0;
  font-size: 0.75rem;
  color: #475569;
}

.cr-level-card li {
  margin-bottom: 0.25rem;
}

.cr-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.65rem 1rem;
  font-size: 0.86rem;
  color: #334155;
  margin-bottom: 1rem;
}

.cr-info-grid dt {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  margin: 0;
}

.cr-info-grid dd {
  margin: 0.1rem 0 0;
}

.cr-link-btn {
  border: none;
  background: none;
  color: #0f766e;
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
}

.cr-link-btn:hover {
  text-decoration: underline;
}

@media (max-width: 1100px) {
  .cr-stats,
  .cr-charts,
  .cr-stat-grid,
  .cr-level-grid,
  .cr-info-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cr-flow {
    grid-template-columns: 1fr;
  }

  .cr-flow__arrow {
    transform: rotate(90deg);
  }
}

@media (max-width: 700px) {
  .cr-stats,
  .cr-charts,
  .cr-stat-grid,
  .cr-level-grid,
  .cr-info-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/CommissionReportPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;;;;;IAKE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;AACF","sourcesContent":[".cr-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.cr-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.cr-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.cr-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.95rem 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.cr-stat span,\n.cr-stat small {\n  display: block;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.cr-stat small {\n  margin-top: 0.2rem;\n}\n\n.cr-stat strong {\n  display: block;\n  font-size: 1.25rem;\n  color: #0f172a;\n  margin: 0.15rem 0;\n}\n\n.cr-charts {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.cr-chart-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.cr-chart-card h3 {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n  color: #0f172a;\n}\n\n.cr-chart-card__body {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n}\n\n.cr-donut {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.cr-donut__center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.cr-donut__center strong {\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.cr-donut__center span {\n  font-size: 0.7rem;\n  color: #64748b;\n}\n\n.cr-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: #475569;\n}\n\n.cr-legend li {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.cr-legend span {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.cr-legend strong {\n  margin-left: auto;\n  color: #0f172a;\n}\n\n.cr-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.cr-bar-row {\n  display: grid;\n  grid-template-columns: 88px 1fr 72px;\n  gap: 0.5rem;\n  align-items: center;\n  font-size: 0.78rem;\n}\n\n.cr-bar-row__label {\n  color: #475569;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cr-bar-row__track {\n  height: 10px;\n  background: #f1f5f9;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.cr-bar-row__fill {\n  height: 100%;\n  border-radius: 999px;\n  min-width: 0;\n}\n\n.cr-bar-row__value {\n  text-align: right;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.cr-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  margin-bottom: 1rem;\n}\n\n.cr-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  align-items: flex-end;\n  margin-bottom: 0.9rem;\n}\n\n.cr-toolbar form,\n.cr-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  align-items: flex-end;\n  flex: 1 1 280px;\n}\n\n.cr-toolbar input,\n.cr-toolbar select,\n.cr-filters input,\n.cr-filters select {\n  border: 1px solid #dbe2ea;\n  border-radius: 8px;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.86rem;\n  font-family: inherit;\n}\n\n.cr-toolbar form input[type=\"search\"] {\n  flex: 1;\n  min-width: 180px;\n}\n\n.cr-toolbar label,\n.cr-filters label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #64748b;\n}\n\n.cr-toolbar button,\n.cr-btn-view,\n.cr-btn-primary {\n  border: none;\n  border-radius: 8px;\n  padding: 0.45rem 0.8rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.cr-btn-ghost {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 8px;\n  padding: 0.45rem 0.8rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.cr-export {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  border: none;\n  border-radius: 8px;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.cr-export:disabled,\n.cr-btn-primary:disabled,\n.cr-btn-view:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.cr-toast {\n  margin: 0 0 0.75rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n\n.cr-toast--success {\n  color: #166534;\n  background: rgba(22, 101, 52, 0.1);\n}\n\n.cr-toast--error {\n  color: #b91c1c;\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.cr-empty {\n  text-align: center;\n  color: #64748b;\n  padding: 1.5rem 0.6rem;\n}\n\n.cr-empty i {\n  display: block;\n  font-size: 1.5rem;\n  margin-bottom: 0.45rem;\n}\n\n.cr-table-wrap {\n  overflow-x: auto;\n}\n\n.cr-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.cr-table th {\n  padding: 0.7rem 0.75rem;\n  text-align: left;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #f8fafc;\n  background: #0f172a;\n  white-space: nowrap;\n}\n\n.cr-table td {\n  padding: 0.7rem 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n  color: #1e293b;\n  vertical-align: top;\n}\n\n.cr-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.cr-table--nested {\n  font-size: 0.8rem;\n}\n\n.cr-table--nested th {\n  background: #334155;\n}\n\n.cr-nested-cell {\n  background: #f8fafc !important;\n  padding: 0.6rem 0.75rem 1rem !important;\n}\n\n.cr-user-mini {\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n}\n\n.cr-user-mini strong {\n  color: #0f172a;\n}\n\n.cr-user-mini span {\n  font-size: 0.75rem;\n  color: #64748b;\n}\n\n.cr-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.12rem 0.48rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.cr-chip--ok {\n  background: rgba(13, 148, 136, 0.14);\n  color: #0f766e;\n}\n\n.cr-chip--pending {\n  background: rgba(217, 119, 6, 0.14);\n  color: #b45309;\n}\n\n.cr-chip--bad {\n  background: rgba(220, 38, 38, 0.12);\n  color: #b91c1c;\n}\n\n.cr-chip--muted {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.cr-chip--level {\n  background: rgba(15, 118, 110, 0.12);\n  color: #0f766e;\n}\n\n.cr-chip--staking {\n  background: rgba(15, 118, 110, 0.12);\n  color: #0f766e;\n}\n\n.cr-chip--brokerage {\n  background: rgba(37, 99, 235, 0.12);\n  color: #1d4ed8;\n}\n\n.cr-chip--buy {\n  background: rgba(22, 163, 74, 0.12);\n  color: #15803d;\n}\n\n.cr-chip--sell {\n  background: rgba(220, 38, 38, 0.12);\n  color: #b91c1c;\n}\n\n.cr-pagination {\n  margin-top: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.cr-pagination label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.cr-pagination select,\n.cr-pagination button {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.35rem 0.65rem;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.cr-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cr-pagination div {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.cr-help {\n  margin: 0 0 1rem;\n  padding: 0.65rem 0.8rem;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  border-radius: 10px;\n  color: #0f766e;\n  font-size: 0.85rem;\n}\n\n.cr-muted {\n  color: #64748b;\n  font-size: 0.85rem;\n  margin: 0;\n}\n\n.cr-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.cr-tabs {\n  display: flex;\n  gap: 0.45rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.cr-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.5rem 0.95rem;\n  font-size: 0.86rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.cr-tab--active {\n  color: #fff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n}\n\n.cr-tab__count {\n  font-weight: 600;\n  opacity: 0.85;\n}\n\n.cr-detail-head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.7rem;\n  margin-bottom: 0.85rem;\n}\n\n.cr-detail-head h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  color: #0f172a;\n}\n\n.cr-detail-head p {\n  margin: 0.2rem 0 0;\n  color: #64748b;\n  font-size: 0.85rem;\n}\n\n.cr-detail-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  align-items: center;\n  margin-bottom: 0.85rem;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.cr-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.7rem;\n  margin-bottom: 1rem;\n}\n\n.cr-stat-grid div {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.7rem 0.8rem;\n}\n\n.cr-stat-grid span,\n.cr-stat-grid small {\n  display: block;\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.cr-stat-grid strong {\n  display: block;\n  margin: 0.2rem 0;\n  font-size: 1.05rem;\n  color: #0f172a;\n}\n\n.cr-flow {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 0.75rem;\n  align-items: stretch;\n  margin-bottom: 1rem;\n}\n\n.cr-flow__box {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.9rem 1rem;\n}\n\n.cr-flow__box h3 {\n  margin: 0 0 0.35rem;\n  font-size: 0.88rem;\n  color: #0f172a;\n}\n\n.cr-flow__box p {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.cr-flow__box strong {\n  display: block;\n  margin: 0.35rem 0 0.15rem;\n  font-size: 1.2rem;\n  color: #0f172a;\n}\n\n.cr-flow__arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f766e;\n  font-size: 1.2rem;\n}\n\n.cr-preview-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n}\n\n.cr-preview-head h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.cr-level-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.65rem;\n  margin-bottom: 1rem;\n}\n\n.cr-level-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.7rem;\n}\n\n.cr-level-card__lvl {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #0f766e;\n  text-transform: uppercase;\n}\n\n.cr-level-card__count {\n  display: block;\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0.15rem 0;\n}\n\n.cr-level-card ul {\n  list-style: none;\n  margin: 0.35rem 0 0;\n  padding: 0;\n  font-size: 0.75rem;\n  color: #475569;\n}\n\n.cr-level-card li {\n  margin-bottom: 0.25rem;\n}\n\n.cr-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.65rem 1rem;\n  font-size: 0.86rem;\n  color: #334155;\n  margin-bottom: 1rem;\n}\n\n.cr-info-grid dt {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #64748b;\n  margin: 0;\n}\n\n.cr-info-grid dd {\n  margin: 0.1rem 0 0;\n}\n\n.cr-link-btn {\n  border: none;\n  background: none;\n  color: #0f766e;\n  font-weight: 700;\n  font-size: 0.82rem;\n  cursor: pointer;\n  font-family: inherit;\n  padding: 0;\n}\n\n.cr-link-btn:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 1100px) {\n  .cr-stats,\n  .cr-charts,\n  .cr-stat-grid,\n  .cr-level-grid,\n  .cr-info-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .cr-flow {\n    grid-template-columns: 1fr;\n  }\n\n  .cr-flow__arrow {\n    transform: rotate(90deg);\n  }\n}\n\n@media (max-width: 700px) {\n  .cr-stats,\n  .cr-charts,\n  .cr-stat-grid,\n  .cr-level-grid,\n  .cr-info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
